import ApiService from './api.service';

export default {
  uploadAttachment(visitId, file) {
    const formData = new FormData();
    formData.append('file', file.files[0]);
    const urlParams = `?description=${file.description}&title=${file.title}`;

    return ApiService.post(`appointments/${visitId}/attachments${urlParams}`, formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
  },
  getAttachemntsList(visitId) {
    return ApiService.get(`appointments/${visitId}/attachments`);
  },
  deleteAttachment(visitId, attachmentId) {
    return ApiService.delete(`appointments/${visitId}/attachments/${attachmentId}`);
  },
  closeVisit(visitId) {
    return ApiService.post(`appointments/${visitId}/action`, {
      command: 'close',
    });
  },
  createVisit(visitId) {
    return ApiService.post(`appointments/${visitId}`);
  },
  copyVisit(visitId, fromVisitId) {
    return ApiService.post(`appointments/${visitId}/copy/${fromVisitId}`);
  },
};



// WEBPACK FOOTER //
// ./src/services/visit.service.js